import { HttpClient, HttpContext } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens';
import { EnvConfig } from '@shared/definitions';
import { Observable } from 'rxjs';

import { SKIP_ERROR_INTERCEPTOR } from '../application/errors/error.interceptor';

@Injectable({
  providedIn: 'root',
})
export class SessionsService {
  private readonly baseUrl: string;

  constructor(@Inject(ENV_CONFIG) private readonly config: EnvConfig, private readonly client: HttpClient) {
    this.baseUrl = `${config.api}/v1.0/sessions`;
  }

  createSession(frontendSessionId: string, shopId: string): Observable<{ id: string }> {
    return this.client.post<{ id: string }>(this.baseUrl, {
      frontend_session_id: frontendSessionId,
      shop_id: shopId,
    });
  }

  claimSession(sessionId: string, cartId?: string | null): Observable<void> {
    // Claiming is background attribution the buyer never triggers, and ShopSessionService recovers
    // from a session the server no longer knows on its own, so a failure must not reach the global
    // error snackbar (PAUL-2772).
    const options = {
      context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true),
      ...(cartId ? { params: { cart_id: cartId } } : {}),
    };
    return this.client.post<void>(`${this.baseUrl}/${sessionId}/claim`, {}, options);
  }
}
